export default {
  "en": {
    "issue_category": {
      "labels": {
        "category_name": "Category name",
        "integration_warning": "An integration with the After care module on your platform is active. If you want to create or edit categories, please ask us.",
        "new_category": "New snagging category"
      }
    }
  }
}